import {useNavigate} from "react-router";
import {useEffect, useState} from "react";
import {useAuthStore} from "../../../store/auth.store";
import {PartnerApi} from "../../../api/partner.api";
import {useOpportunitiesStore} from "../../../store/opportunities.store";
import {useOpportunities} from "../../../hook/partner/opportunities.partner.hook";
import {useOpportunity} from "../../../hook/partner/opportunity.partner.hook";
import {useTranslation} from "../../../hooks/useTranslation";

export default function OpportunityAddItemsForm({handleClose, items = null}) {
    const { t } = useTranslation();
    const opportunitiesMutation = useOpportunities();
    const opportunityMutation = useOpportunity();

    const [error, setError] = useState(null);
    const [selectedOpportunity, setSelectedOpportunity] = useState(null);
    const [selectedOpportunityVariation, setSelectedOpportunityVariation] = useState(null);

    const navigate = useNavigate();

    const token = useAuthStore((state) => state.token);
    const opportunities = useOpportunitiesStore((state) => state.opportunities);
    const opportunity = useOpportunitiesStore((state) => state.opportunity);
    const filter = useOpportunitiesStore((state) => state.filter);

    useEffect(() => {
        if (token && !opportunities) {
            opportunitiesMutation.mutate(
                {
                    token,
                    page: 1,
                    filter: {
                        ...filter,
                        current_state_id: [0, 10, 25, 50, 75]
                    }, rowsSelected: 10
                }
            )
        }
    }, [token]);

    useEffect(() => {
        if (selectedOpportunity) {
            if (!opportunity || opportunity.opportunity_id !== selectedOpportunity) {
                opportunityMutation.mutate({token, id: selectedOpportunity});
            }
        }
    }, [selectedOpportunity]);

    const addProductToOpportunity = (event) => {
        event.preventDefault();
        setError(null);

        if (!selectedOpportunity) {
            setError(t("opportunities.selectOpportunity"));
            return;
        }

        if (!selectedOpportunityVariation) {
            setError(t("opportunities.selectVariant"));
            return;
        }

        const result = PartnerApi.opportunityVariantProductAddItems({
            token,
            opportunity_id: selectedOpportunity,
            variation_id: selectedOpportunityVariation,
            items: items.map((item) => ({
                product_id: item.product_id,
                quantity: item.quantity,
                sn: item.sn
            })),
        });
        result.then((result) => {
            if ("error" in result) {
                setError(result.error);
                return;
            }

            if ("opportunity_id" in result) {
                handleClose();
                return navigate("/prilezitost/" + result.opportunity_id);
            }
        });
        return false;
    }

    return (
        <form onSubmit={(e) => addProductToOpportunity(e)}>

            {error && (
                <p className="alert alert-danger">{error}</p>
            )}

            {items && items.length > 0 && (

                <div className="mb-10">
                    <label className=" form-label">{t("common.items")}</label>
                    <table className="table table-bordered">
                        <tbody>

                        {items.map((item, index) => (
                            <tr key={index}>
                                <td>{item.name}</td>
                                <td>{item.sku}</td>
                                <td>{item.sn}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            )}

            <div className="mb-2">
                <label htmlFor="formObchodniNazev"
                       className="required form-label">{t("opportunities.selectOpportunity")}</label>
            </div>

            {opportunities?.data?.length > 0 && (
                <div className="overflow-auto mb-10" style={{maxHeight: "250px"}}>
                    <div
                        className="menu menu-rounded menu-column menu-gray-600 menu-state-bg fw-semibold">
                        {opportunities?.data?.map((opportunity, opportunity_key) => (
                            <div className="menu-item" key={opportunity_key}>
                                <div
                                    onClick={() => setSelectedOpportunity(opportunity.opportunity_id)}
                                    className={"cursor-pointer menu-link " + (selectedOpportunity == opportunity.opportunity_id ? "active" : "")}
                                >
                                    {selectedOpportunity == opportunity.opportunity_id && (
                                        <span className="menu-icon" data-kt-element="icon">
                                                                    <i className="ki-duotone ki-check fs-2">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                    )}

                                    <span className="menu-title">
                                    {opportunity.description}<br/>
                                       {t("opportunities.endCustomer")}: {opportunity.end_customer?.name}<br/>
                                    {t("opportunities.dateCreated")}: {new Date(opportunity.create_date).toLocaleDateString()}
                                </span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            <div className="mb-2">
                <label htmlFor="formObchodniNazev"
                       className="required form-label">{t("opportunities.selectVariant")}</label>
            </div>

            {opportunity?.opportunity_variations?.length > 0 && (
                <div className="overflow-auto mb-10" style={{maxHeight: "170px"}}>
                    <div
                        className="menu menu-rounded menu-column menu-gray-600 menu-state-bg fw-semibold">
                        {opportunity?.opportunity_variations?.map((variation, variation_key) => (
                            <div className="menu-item" key={variation_key}>
                                <div
                                    onClick={() => setSelectedOpportunityVariation(variation.variation_id)}
                                    className={"cursor-pointer menu-link " + (selectedOpportunityVariation == variation.variation_id ? "active" : "")}
                                >
                                    {selectedOpportunityVariation == variation.variation_id && (
                                        <span className="menu-icon" data-kt-element="icon">
                                            <i className="ki-duotone ki-check fs-2">
                                                <span className="path1"></span>
                                                <span className="path2"></span>
                                            </i>
                                        </span>
                                    )}

                                    <span className="menu-title">
                                    {variation.description}
                                </span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            <button type="submit" className="btn btn-primary">{t("common.add")}</button>
        </form>
    );
}